import React, { useState } from "react";
import { useEffect } from "react";
import { Container, Image } from "react-bootstrap";

const productImages = [
  "https://cdn.shopify.com/s/files/1/0591/4329/products/S13_BoxBehind_GoogleGrey_BigSize_Facetheory_2_800x.progressive.jpg?v=1656510464",
  "https://cdn.shopify.com/s/files/1/0591/4329/products/31k1a022-retouched1080x1080copy2_800x.progressive.jpg?v=1656510464",
  "https://cdn.shopify.com/s/files/1/0591/4329/products/3K1A05771080x1080_800x.progressive.jpg?v=1656510464",
  "https://cdn.shopify.com/s/files/1/0591/4329/products/81080x1080_800x.progressive.jpg?v=1656510464",
];

const ImageGallery = ({ singleProductData, isLoading, isError }) => {
  const [image, setImage] = useState("");
  useEffect(() => {
    if (singleProductData) {
      setImage(singleProductData?.images?.[0]);
    }
  }, [singleProductData]);

  return (
    <div className="d-flex flex-md-row flex-column-reverse">
      <div className="d-flex flex-md-column flex-row justify-content-md-start justify-content-center me-md-4 mt-md-0 mt-3">
        {singleProductData?.images?.length > 0 &&
          singleProductData?.images?.map((img, _idx) => (
            <div
              key={_idx}
              style={{
                height: "3.75rem",
                width: "3.75rem",
                marginBottom: "5px",
                cursor: "pointer",
              }}
            >
              {isLoading && <p>Loading..</p>}
              <Image
                src={img}
                alt="product image"
                className={`${
                  image === img && "border border-dark border-3 mt-2"
                }`}
                onClick={() => setImage(img)}
                fluid
              />
            </div>
          ))}
      </div>
      <div className="w-100">
        {isLoading && <p>Loading..</p>}
        {isError && (
          <p className="text-danger mt-4 fs-3">There is something wrong</p>
        )}
        <Image
          style={{ objectFit: "cover", width: "100%" }}
          src={image}
          alt="product images"
          fluid
        />
      </div>
    </div>
  );
};

export default ImageGallery;
